import React from 'react';
import { Route, Switch } from 'react-router-dom';

//import ConfirmPutAwayForm from '../../../PutAway/ConfirmPutAway/index';
import PrimaryUpload from '../../../Receiving/PrimaryUpload/index';
import PrimaryDashboard from '../../../Receiving/PrimaryDashboard/index';
import InboundReceiving from '../../../Receiving/InboundReceiving/index';
import ViewExcess from '../../../Receiving/ViewExcess/index';
import ViewMisMatch from '../../../Receiving/ViewMisMatch/index';

import SplitCrate from '../../../Receiving/SplitCrate/index';
import createASN from '../../../Receiving/createASN/index';
import viewInbound from '../../../Receiving/viewInbound/index';
import viewMissingProduct from '../../../Receiving/viewMissingProduct/index';
import missingProductInfo from '../../../Receiving/missingProductInfo/index';
import POSorting from '../../../Receiving/POSorting/index'; 
import PurchaseReturn from '../../../Receiving/PurchaseReturn/index'; 
import PurchaseReturnApproval from '../../../Receiving/PurchaseReturnApproval/index'; 

import ConfirmSaleable from '../../../Receiving/ConfirmSaleable/index'; 
import ConfirmNonSaleable from '../../../Receiving/ConfirmNonSaleable/index'; 
import RetailerDCMapping from '../../../Receiving/RetailerDCMapping/index';
import uploadPendingASN from '../../../Receiving/uploadPendingASN/index';
import SendToHHT from '../../../Receiving/SendToHHT/index';
import createUser from '../../../Receiving/createUser/index';
import createbulkUser from '../../../Receiving/createbulkuser/index';
import createInboundDelivery from '../../../Receiving/createInboundDelivery/index';
import BulkPurchaseReturn from '../../../Receiving/BulkPurchaseReturn/index';
import POCreation from '../../../Receiving/POCreation/index';
import createPO from '../../../Receiving/createPO/index';
import viewSinglePO from '../../../Receiving/viewSinglePO/index';
import viewApprovalPO from '../../../Receiving/viewApprovalPO/index';
import editSinglePO from '../../../Receiving/editSinglePO/index';










//import PrintDetailForm from '../../../PutAway/PrintDetail/index';
//import PrintPutAwayForm from '../../../PutAway/PrintPutAway/index.jsx';



export default () => (
  <Switch>
    <Route path="/receiving/primaryupload" component={PrimaryUpload} />
    <Route path="/receiving/create_ASN" component={createASN} />
    <Route path="/receiving/view_inbound" component={viewInbound} />
    <Route path="/receiving/view_excess" component={ViewExcess} />
    <Route path="/receiving/view_mismatch" component={ViewMisMatch} />
    <Route path="/receiving/po_sorting" component={POSorting} />
    <Route path="/receiving/purchase_return" component={PurchaseReturn} />
    <Route path="/receiving/purchase_return_approval" component={PurchaseReturnApproval} />
    <Route path="/receiving/confirm_saleable" component={ConfirmSaleable} />
    <Route path="/receiving/confirm_non_saleable" component={ConfirmNonSaleable} />
    <Route path="/receiving/view_missing_product" component={viewMissingProduct} />
    <Route path="/receiving/missing_product_info" component={missingProductInfo} />
    <Route path="/receiving/create_Inbound_Delivery" component={createInboundDelivery} />
    <Route path="/receiving/send_to_hht" component={SendToHHT} />
    <Route path="/receiving/create_user" component={createUser} />
    <Route path="/receiving/create_bulk_user" component={createbulkUser} />
    <Route path="/receiving/assign_user" component={PrimaryDashboard} />
    <Route path="/receiving/retailer_dc_mapping" component={RetailerDCMapping} />
    <Route path="/receiving/inbound_receiving" component={InboundReceiving} />
    <Route path="/receiving/upload_pending_data" component={uploadPendingASN} />
    <Route path="/receiving/split_crate" component={SplitCrate} />    
    <Route path="/receiving/bulk_purchase_return" component = {BulkPurchaseReturn} />
    <Route path="/receiving/purchase_order" component={POCreation} />
    <Route path="/receiving/create_new_po" component={createPO} />
    <Route path="/receiving/view_single_po_details" component={viewSinglePO} />
    <Route path="/receiving/view_approval_po_details" component={viewApprovalPO} />
    <Route path="/receiving/edit_po_details" component={editSinglePO} />




  </Switch>
);